import { AdminBarberRepository } from "../../Repository";

export async function deleteReservation(
  reservationId: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.deleteReservation(reservationId);
}
